function StarIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Icons">
        <path
          id="Vector"
          d="M10.3249 19.6319L13.9999 17.4152L17.6749 19.661L16.7124 15.461L19.9499 12.661L15.6916 12.2818L13.9999 8.31518L12.3083 12.2527L8.04993 12.6319L11.2874 15.461L10.3249 19.6319ZM7.67082 23.291L9.34228 16.0937L3.75806 11.2543L11.1259 10.6149L13.9999 3.82812L16.8739 10.6149L24.2418 11.2543L18.6576 16.0937L20.329 23.291L13.9999 19.4725L7.67082 23.291Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default StarIcon;
